import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56711cc4")

_pushScopeId("data-v-56711cc4")
const _hoisted_1 = { class: "ui__generationDate_main" }
const _hoisted_2 = { class: "ui__generationDate_body" }
const _hoisted_3 = { class: "ui__generationDate_title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, " 该报告于 " + _toDisplayString(_ctx.state.generationDate) + " 出具 ", 1)
    ])
  ]))
})